<div style="width:95%;min-width:500px;" *ngIf="roles.length > 0">
  <span> <button class="btn btn border" (click)="saveSystemPermission()">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
  <br>
  <hr /><br>
  <form [formGroup]="form" class="mb-3">
    <div class="col-md-12">
      <label>
        Medlems-id
      </label>
      <input id="memberId" type="text" class="form-control form-control-sm" formControlName="memberId">
    </div>
    <div class="col-md-12">
      <label>
        Roll
      </label>
      <p-select *ngIf="roles.length > 0" appendTo="body" [options]="roles" formControlName="roleId" [style]="{'width':'100%', 'height':'40px'}" (onChange)="setRole($event)"></p-select>
    </div>
    <div class="col-md-12">
      <label>
        Notering
      </label>
      <input id="note" type="text" class="form-control form-control-sm" formControlName="note">
    </div>
    <div class="col-md-12">
      <label>
        Epost (systemmeddelanden)
      </label>
      <input id="emailForSystemMessages" type="text" class="form-control form-control-sm" formControlName="emailForSystemMessages">
    </div>
  </form>
</div>
